import Vue from 'vue'
import axios from 'axios'
import Storage from 'vue-ls'
import queryString from 'query-string'
import { userTypeMap } from '@/dicts/member'

Vue.use(Storage)
const service = axios.create()

let requestBackup = null
window.__MICRO_ROOT__?.eventBus?.on('user.login.modal:success', () => {
  if (requestBackup) {
    service(requestBackup.request).then(function (data) {
      requestBackup.resolve(data)
      requestBackup = null
    }).catch(function (err) {
      requestBackup.reject(err)
      requestBackup = null
    })
  }
})

const imageTokenKey = 'retail_captcha_token'
const sliderTokenKey = 'retail_slider_token'

// request interceptor
service.interceptors.request.use(request => {
  const token = Vue.ls.get('USER_CENTER_TOKEN')
  const imageCaptchaToken = sessionStorage.getItem(imageTokenKey)
  const sliderCaptchaToken = sessionStorage.getItem(sliderTokenKey)
  // NOTE: 当消费验证码的请求前还有其他请求时使用此参数，防止验证码被提前消费
  const passByConsumeToken = request.headers['passby-consume-token']

  if (imageCaptchaToken && !passByConsumeToken) {
    request.headers['captcha-token'] = imageCaptchaToken
    sessionStorage.removeItem(imageTokenKey)
  }

  if (sliderCaptchaToken && !passByConsumeToken) {
    request.headers['slider-token'] = sliderCaptchaToken
    sessionStorage.removeItem(sliderTokenKey)
  }

  if (token) {
    request.headers.token = token
  }

  if (window.__MICRO_ROOT__?.airline) {
    const airline = window.__MICRO_ROOT__.airline.toLocaleUpperCase()
    request.headers.airline = airline
    request.headers.channel = 'C' + airline
  }

  // 清除非国际票相关请求的入参
  if (!request.data?.ifInternational) {
    delete request.data?.ifInternational
  }

  // NOTE: 8L - 管理员操作统一添加userId
  const userType = window.__MICRO_ROOT__?.user?.get()?.userType
  if (userTypeMap[userType] === 'CARRIER') {
    const query = queryString.parse(location.search)
    const userId = query.outUserId
    if (userId && request.data) {
      request.data.userId = userId
    }
  }

  // NOTE: 支持cms预览
  if (request.url?.includes('/bff/cms')) {
    const url = new URL(location.href)
    if (url.searchParams?.get('__preview__')) {
      request.headers.cmspreview = true
    }
  }

  return request
}, err => {
  return Promise.reject(err)
})

service.interceptors.response.use(response => {
  return new Promise((resolve, reject) => {
    const { status, data: result, config } = response
    if (status === 200) {
      const { success, status, code, data, message } = result
      // code === 0 兼容请求用户中心接口
      if (success || status === 'success' || code === 0) {
        resolve(data)
      } else {
        if (code === '100020006') {
          requestBackup = {
            request: config,
            resolve,
            reject
          }
          window.__MICRO_ROOT__.eventBus.emit('user.expired', null, {
            isModal: true
          })
        } else {
          const err = new Error(message || '网络异常，请稍后再试！')
          err.code = code

          if (data) {
            err.data = data
          }

          reject(err)
        }
      }
    } else {
      reject(new Error(`status: ${status}`))
    }
  })
}, err => {
  console.error('request error: ', err)
  return Promise.reject(err)
})

export default {
  vm: {},
  install (Vue) {
    Vue.prototype.$axios = service
  }
}

export {
  service as axios
}
